class ToggleModal {
    constructor(target) {
      this.target = target;
      this.videoId = target.dataset.url.slice(-11);
      this.loadIframePlayerAPI();
      this.open();
      this.close();
    }
    loadIframePlayerAPI() {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    onYouTubeIframeAPIReady() {
      let ytPlayer = new YT.Player('player', {
        videoId: this.videoId,
        playerVars: {
          'autoplay': 1,
          'controls': 1
        }
      });
    }
    remakePlayerElement() {
      const modal = document.querySelector('#modal-video');
      modal.removeChild(modal.firstElementChild);
      let tag = document.createElement('div');
      tag.id = 'player';
      modal.appendChild(tag);
    }
  
    open() {
      this.target.addEventListener('click', event => {
        this.onYouTubeIframeAPIReady();
        document.querySelector('#modal-video').classList.add('open');
        document.querySelector('#modal-video').classList.remove('close');
      });
    }
  
    close() {
      document.querySelector('.js-modal-video-close').addEventListener('click', event => {
        document.querySelector('#modal-video').classList.add('close');
        document.querySelector('#modal-video').classList.remove('open');
        this.remakePlayerElement();
      });
    }
  }
  
  document.addEventListener('DOMContentLoaded', event => {
    document.querySelectorAll('.js-modal-video-open').forEach(element => {
      new ToggleModal(element);
    });
  });
  
  let youTube = $('#youTube .iframeWrap');
  
  let youTubePlay = (targetTag) => {
    targetTag.click(function () {
      let getIframe = $(this).html();
      if ($('#modalBack').css('display') != 'block' || $('#displayYouTube').css('display') != 'block') {
        $('#displayYouTube').html(getIframe);
        $('#modalBack').slideDown('fast');
        $('#displayYouTube').append('<p class="modalCloseBtn">閉じる</p>');
        $('.modalCloseBtn').fadeIn('fast');
      }
      $('#displayYouTube iframe').height(($('#displayYouTube iframe').width()) * 0.5625);
      
      $('.modalCloseBtn').click(function () {
        $('#displayYouTube').html('');
        $('#modalBack').slideUp('fast');
        $('.modalCloseBtn').fadeOut('fast');
      });
    });
  }
  
  youTubePlay(youTube);
  
  $('#modalBack').click(function () {
    $('#displayYouTube').html('');
    $('#modalBack').slideUp('fast');
    $('.modalCloseBtn').fadeOut('fast');
  });
  
  $(document).ready(function () {
    $('.iframeWrap iframe').height(($('.iframeWrap iframe').width()) * 0.5625);
  });
  
  $(window).resize(function(){
    $('.iframeWrap iframe').height(($('.iframeWrap iframe').width()) * 0.5625);
    $('#displayYouTube iframe').height(($('#displayYouTube iframe').width()) * 0.5625);
  });
  